module.exports = __webpack_public_path__ + "img/img7.a5df3d40.jpg";